// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"iUaVr7bURENkxMzzhJtmtg=="};